module.exports = __webpack_public_path__ + "img/cross-red.75d37785.svg";